/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { connect } from 'inferno-redux';
// actions used to manipulate application state
// actual presentational component that will utilize application state and actions (will be exported after being infused with state/actions)
import UDCFailurePhase from 'components/content/userdatacollection/phases/udcfailure/udcfailure';
import { showLoader, setOutOfContent } from 'redux/actions/embed_status';
import { advanceFrame, submitUDCData, setUniqueState } from 'redux/actions/content_status';



/* ========== ~~~~~~~~~~ USER DATA COLLECTION FAILURE PHASE: PARENT ~~~~~~~~~~ ========== */
// CONTAINER COMPONENT
// interacts with redux (store of application state)
// infuses child component (imported above) with state & actions by mapping and then connecting them

// map state
const mapStateToProps = ({ contentStatus, settings, sessionStatus }, { contentId }) => ({
    phase: contentStatus[contentId].uniqueState.phase,
    showFrameForXSeconds: settings.contentSettings[contentId].showFrameForXSeconds,
    contentSignature: contentStatus[contentId].uniqueState.contentSignature,
    userId: sessionStatus.userInfo.userId !== undefined ? sessionStatus.userInfo.userId : null,
    udcId: contentStatus[contentId].uniqueState.udcId,
    embedUUID: settings.embedSettings.embedUUID,
});

// map actions
const mapDispatchToProps = dispatch => ({
    advanceFrame: contentId => dispatch(advanceFrame(contentId)),
    setUniqueState: (contentId, state) => dispatch(setUniqueState(contentId, state)),
    showLoader: state => dispatch(showLoader(state)),
    submitUDCData: (contentId, udcData, isPubPortalPreview, callback) =>
        dispatch(submitUDCData(contentId, udcData, isPubPortalPreview, callback)),
});



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
// utilizes "connect" functionality from redux in order to infuse state/actions as props to child component
// will be utilized from any component that wants to incorporate "Content" component
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(UDCFailurePhase);
